




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class NavComponent extends Vue {

  doLogin () {
    this.$store.dispatch('openid/login')
  }

  doLogout () {
    this.$store.dispatch('openid/logout')
  }

  changeLang (lang: string) {
    this.$i18n.locale = lang
  }

  @Getter('openid/isLoggedIn') loggedIn!: boolean;
}
